import { useContext, useEffect, useState } from 'react';
import BadgesList from '../../components/Badges/BadgesList';
import { LeftDivMain } from '../../components/Div/StyledDiv';
import { StyledMainHeader } from '../../components/StyledText/StyledHeader';
import AlertContext from '../../context/alertContext';
import LoginContext, { IDepartments } from '../../context/loginContext';
import TerminierungContext from '../../context/terminierungContext';
import { TRACK_PAGE_APPOINTMENT_CATEGORY_DEPARTMENT } from '../../globals/trackingGlobals';
import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics';
import { useLanguage } from '../../hooks/useLanguage';
import useScreenResolution from '../../hooks/useScreenResolution';
import { getParticipants } from '../../services/RestServices';

interface IAppointmentCategoryDepartment {
    departments?: IDepartments[];
    handleDepartmentClick(forceNoExtendedPhysicians?: boolean): void;
}

const AppointmentCategoryDepartment = (props: IAppointmentCategoryDepartment) => {
    const { alertdispatch } = useContext(AlertContext);
    const { dispatch } = useContext(LoginContext);
    const { tmdispatch } = useContext(TerminierungContext);
    const [departments, setDepartments] = useState<IDepartments[]>([]);

    const { t } = useLanguage();

    const { trackById } = useGoogleAnalytics();

    const screenSize = useScreenResolution();

    useEffect(() => {
        trackById(TRACK_PAGE_APPOINTMENT_CATEGORY_DEPARTMENT);

        const getDepartmentMacros = async () => {
            if (props.departments) {
                setDepartments(props.departments);
            } else {
                const possibleMacrosResponse: any = await getParticipants(alertdispatch);
                if (possibleMacrosResponse.departments !== undefined) {
                    setDepartments(possibleMacrosResponse.departments);
                }
            }
        };

        getDepartmentMacros();
    }, []);

    useEffect(() => {
        if (departments && departments.length > 0) {
            dispatch({
                type: 'SETDEPARTMENTS',
                departments: departments,
            });
        }
    }, [departments]);

    const getBadgesList = () => {
        const allBadges: string[] = [];
        departments.forEach((e) => {
            allBadges.push(e.name);
        });

        return allBadges;
    };

    const handleDepartmentClick = (departmentName: string) => {
        const selectedDepartment = departments.find((dep) => dep.name === departmentName);
        if (selectedDepartment) {
            let forceNoExtendedPhysicians = false;
            if (selectedDepartment.reasons && selectedDepartment.reasons.length > 0) {
                if (selectedDepartment.reasons[0].slotForbidden) {
                    // now switch to old appointment booking view with seperated Calendar and Physician selection, no extendedPhysician
                    forceNoExtendedPhysicians = true;
                }
            }

            tmdispatch({
                type: 'SELECTDEPARTMENT',
                selectedDepartment: selectedDepartment,
            });
            props.handleDepartmentClick(forceNoExtendedPhysicians);
        }
    };

    return (
        <LeftDivMain>
            <StyledMainHeader>{t('ANMELD', 'Fachrichtung wählen')}</StyledMainHeader>
            <p>{t('ANMELD', 'Wählen Sie die gewünschte Fachrichtung aus')}</p>
            <br />
            <BadgesList
                badgesList={getBadgesList()}
                showAsGrid={screenSize.width < 440 ? true : false}
                handleBadgeClick={handleDepartmentClick}
            />
        </LeftDivMain>
    );
};

export default AppointmentCategoryDepartment;
